CheckoutV2.ReviewV2 = function(checkout) {
    var review = this;

    this._init = function() {
        review.$prop65 = $('#prop65-section');
        review.$reviewTab = $('.js-progress-review');
        checkout.registerStepChangedListener(review.showProp65);
    };

    this.renderPaymentInfo = function() {
        // Massage the active payment data into review data for the template
        var reviewData = [];
        checkout.payment.activeMethods.forEach(function(method){
            reviewData.push(checkout.payment.models.paymentReviewFromPaymentMethod(method));
        });

        checkout.payment.activeBalances.forEach(function(method){
            reviewData.push(checkout.payment.models.paymentReviewFromBalanceMethod(method));
        });

        var content = '';
        content += reviewData.map(function(data) {
            return Jemplate.process( 'includes/partials/payment/review/method.html', data)
        }).join("");

        $('.payment-method-creditcard-review-container').html(content);
        $('.payment-methods-review .card-address').popover();

        // Listener to deal with the change payment link to send the user to payment step
        $('.js-change-payment-review').on('click', function(e) {
            e.preventDefault();
            // Toggle review step disabled on step change
            checkout.nextStep( false, 3 );
        });
    };

    this.showLoading = function(){
        $('.js-review.js-payment-method').find('.loading-overlay').show();
    };

    this.hideLoading = function(){
        $('.js-review.js-payment-method').find('.loading-overlay').hide();
    };
    
    
    review.showProp65 = function() {
        if ((checkout.currentStepName() == 'review') && (checkout.shippingProp65)) {
            review.$prop65.html(
                Jemplate.process('includes/partials/prop65Warning.html')
            )
        }
        else {
            review.$prop65.html('')
        }
    };
    

    this._init();
};
